import { defineStore } from "pinia";
import { markRaw } from "vue";

import {
  api,
  type Result,
  type ResultOkRef,
  Success,
  watchRequest,
} from "../api";
import {
  AdminOrderEmailPreferencesSchema,
  type AdminOrderEmailPreferences,
  type AdminOrderEmailPreferencesUpdate,
} from "../schemas/notificationSettings";

class NotificationSettingsApi {
  private readonly url = "/notification-settings/";

  getAdminOrderEmailPreferences(): ResultOkRef<
    Success<AdminOrderEmailPreferences>
  > {
    return watchRequest(this.url, AdminOrderEmailPreferencesSchema);
  }

  updateAdminOrderEmailPreferences(
    payload: AdminOrderEmailPreferencesUpdate,
  ): Promise<Result<AdminOrderEmailPreferences>> {
    return api.patch(this.url, AdminOrderEmailPreferencesSchema, payload);
  }
}

const store = defineStore("notification-settings", () => ({
  api: markRaw(new NotificationSettingsApi()),
}));

export function useNotificationSettings() {
  return store().api;
}
